import { Button, Offcanvas, OffcanvasBody } from "react-bootstrap";
import { useSelector } from "react-redux";
import styled from "styled-components";
import dummy from "../../images/person-outline.png";
import { Link } from "react-router-dom";
import { AiFillDashboard } from "react-icons/ai";
import { IconSelector } from "./IconSelector";
import { useEffect } from "react";
import { ontLogo } from "./A01_Navbar";

export const MenuOffCanvas = (props) => {
  const [sidebar, setSidebar] = props.sidebar;
  const [foundImage, setFoundImage] = props.foundImage;
  const { handleClose, styles, handleLogout } = props;
  const userDetail = useSelector((state) => state.user.detail);
  const user = useSelector((state) => state.user);
  const userLineProfile = useSelector((state) => state.user.lineProfile);

  let okk = false;
  return (
    <Offcanvas
      show={sidebar}
      onHide={handleClose}
      style={{ background: "#ffffff" }}
      placem
      ent="start"
    >
      <div style={{ paddingInline: "50px", paddingBlockStart: "10px" }}>
        {ontLogo}
      </div>
      {okk ? (
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <span style={{ color: "#0413eb" }}>
              {/* ONT {process.env.REACT_APP_VERSION} */}
            </span>
          </Offcanvas.Title>
        </Offcanvas.Header>
      ) : (
        <></>
      )}

      <OffcanvasBody
        style={{
          border: "none",
          borderRadius: "5px 5px",
          marginBottom: "5px",
        }}
      >
        <div style={styles.offCanvasDiv1}>
          {okk ? (
            <div
              style={{
                flex: "1",
                display: "flex",
                // border: "1px solid #25f10a",
                borderRadius: "5px",
                maxHeight: "120px",
                width: "100%",
                // background: "#283477",
              }}
            >
              {/* กรอบรูป */}
              <div style={styles.imageBoxFrame}>
                {/* รูปพนักงาน */}
                {/* <img src={dummy} /> */}
                {foundImage ? (
                  <ImageObj
                    // src={process.env.REACT_APP_PHOTO + user.detail.image_name}
                    src={userLineProfile[0]?.pict_url || dummy}
                    foundImage={foundImage}
                  />
                ) : (
                  <ImageObj src={dummy} />
                )}
              </div>
              {/* รายละเอียดพนักงาน */}
              <div style={styles.staffBox}>
                <UserLineTextOff style={{ color: "white" }}>
                  {userDetail.prefix + "" + userDetail.firstname}
                </UserLineTextOff>
                <UserLineTextOff style={{ color: "#98a8b9" }}>
                  {userDetail.stafftypename}
                </UserLineTextOff>
                <UserLineTextOff style={{ color: "#0a86f3" }}>
                  {`สาขา${userDetail.brchname}`}
                </UserLineTextOff>
              </div>
            </div>
          ) : (
            <></>
          )}

          {/* Menu Container */}
          <div
            style={{
              flex: "5",
              margin: "10px 0 10px 0",
            }}
          >
            {/* Title menu */}
            <div
              style={{
                flex: "1",
                display: "flex",
                height: "100%",
                flexDirection: "column",
              }}
            >
              {/* <div style={styles.menuFrameCover}>เมนูระบบงาน</div> */}
              {/* กรอบเมนู */}
              <div style={styles.menuFrame}>
                {/* เมนู */}

                <li key={"-1"} className="nav-text">
                  <Link to="" onClick={() => setSidebar(!sidebar)}>
                    <AiFillDashboard
                      style={{ color: "blue", marginInline: "20px" }}
                    />
                    <span>DashBoard</span>
                  </Link>
                </li>

                {user?.userMenus?.map((item, index) => {
                  return (
                    <li key={index} className={item.classname}>
                      <Link
                        to={item.linkto}
                        onClick={() => setSidebar(!sidebar)}
                      >
                        <IconSelector
                          style={{ color: "blue", marginInline: "20px" }}
                          iconname={item?.iconname}
                        />
                        <span>{item.menutext}</span>
                      </Link>
                    </li>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* Logout */}
        <div
          style={{
            flex: "1",
            display: "flex",
          }}
        >
          <Button
            variant="danger"
            style={{
              flex: "1",
            }}
            onClick={handleLogout}
          >
            {" "}
            Logout
          </Button>
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};

const ImageObj = styled.img`
  width: ${(p) => (p.foundImage ? 80 : 110)}px;
  height: ${(p) => (p.foundImage ? 80 : 110)}px;
  /* margin-top: -1px; */
  margin-top: ${(prop) => (prop.foundImage ? -1 : -15)}px;
  margin-left: ${(prop) => (prop.foundImage ? 0 : -15)}px;
  background-color: #999191;
  /* background: "#999191", */

  /* opacity:0.9; */
  /* @media only screen and (max-width:1000px){
      width: 100px;
      height: 100px;     
    } */
`;

const UserLineTextOff = styled.p`
  text-align: center;
  padding: 0px;
  margin: 0 0 0 20px;
  font-size: 14px;
`;

// const canvas2 = useMemo(() => {
//     return (
//       <Offcanvas
//         show={sidebar}
//         onHide={handleClose}
//         style={{ background: "#141414" }}
//         placement="start"
//       >
//         <Offcanvas.Header closeButton>
//           <Offcanvas.Title>
//             <span style={{ color: "#0413eb" }}>
//               RAD CONNEXT {process.env.REACT_APP_VERSION}
//             </span>
//           </Offcanvas.Title>
//         </Offcanvas.Header>

//         <OffcanvasBody
//           style={{
//             border: "2px solid #0413eb",
//             borderRadius: "5px 5px",
//             marginBottom: "5px",
//           }}
//         >
//           <div style={styles.offCanvasDiv1}>
//             <div
//               style={{
//                 flex: "1",
//                 display: "flex",
//                 border: "1px solid #25f10a",
//                 borderRadius: "5px",
//                 maxHeight: "120px",
//                 width: "100%",
//                 background: "#283477",
//               }}
//             >
//               {/* กรอบรูป */}
//               <div style={styles.imageBoxFrame}>
//                 {/* รูปพนักงาน */}
//                 {/* <img src={dummy} /> */}
//                 {foundImage ? (
//                   <ImageObj
//                     // src={process.env.REACT_APP_PHOTO + user.detail.image_name}
//                     src={userLineProfile[0]?.pict_url || dummy}
//                     foundImage={foundImage}
//                   />
//                 ) : (
//                   <ImageObj src={dummy} />
//                 )}
//               </div>
//               {/* รายละเอียดพนักงาน */}
//               <div style={styles.staffBox}>
//                 <UserLineTextOff style={{ color: "white" }}>
//                   {userDetail.prefix + "" + userDetail.firstname}
//                 </UserLineTextOff>
//                 <UserLineTextOff style={{ color: "#98a8b9" }}>
//                   {userDetail.stafftypename}
//                 </UserLineTextOff>
//                 <UserLineTextOff style={{ color: "#0a86f3" }}>
//                   {`สาขา${userDetail.brchname}`}
//                 </UserLineTextOff>
//               </div>
//             </div>

//             {/* Menu Container */}
//             <div
//               style={{
//                 flex: "5",
//                 margin: "10px 0 10px 0",
//               }}
//             >
//               {/* Title menu */}
//               <div
//                 style={{
//                   flex: "1",
//                   display: "flex",
//                   height: "100%",
//                   flexDirection: "column",
//                 }}
//               >
//                 <div style={styles.menuFrameCover}>เมนูระบบงาน</div>
//                 {/* กรอบเมนู */}
//                 <div style={styles.menuFrame}>
//                   {/* เมนู */}

//                   <li key={"-1"} className="nav-text">
//                     <Link to="" onClick={() => setSidebar(!sidebar)}>
//                       <AiFillDashboard
//                         style={{ color: "white", marginInline: "20px" }}
//                       />
//                       <span>DashBoard</span>
//                     </Link>
//                   </li>

//                   {user.userMenus &&
//                     user.userMenus.map((item, index) => {
//                       return (
//                         <li key={index} className={item.classname}>
//                           <Link
//                             to={item.linkto}
//                             onClick={() => setSidebar(!sidebar)}
//                           >
//                             <IconSelector
//                               style={{ color: "white", marginInline: "20px" }}
//                               {...{ iconname: item?.iconname }}
//                             />
//                             <span>{item.menutext}</span>
//                           </Link>
//                         </li>
//                       );
//                     })}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Logout */}
//           <div
//             style={{
//               flex: "1",
//               display: "flex",
//             }}
//           >
//             <Button
//               variant="danger"
//               style={{
//                 flex: "1",
//               }}
//               onClick={handleLogout}
//             >
//               {" "}
//               Logout
//             </Button>
//           </div>
//         </OffcanvasBody>
//       </Offcanvas>
//     );
//   }, [sidebar]);
